import {Button, Modal, Spin} from "antd";
import React, {useState, useEffect} from "react";

export const DocumentModal = ({
    visibility,
    onCancel,
    documentUrl,
    title = "Belge Görüntüleyici",
    onApprove,
    isNeedForApproval,
    isApproved,
    isApproveButtonDisabled,
    description
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [iframeUrl, setIframeUrl] = useState("");

    useEffect(() => {
        if (visibility && documentUrl) {
            setIsLoaded(false);
            setHasError(false);
            setIsLoading(true);

            const isPdf = documentUrl.toLowerCase().endsWith(".pdf");
            if (isPdf) {
                setIframeUrl(documentUrl);
            } else {
                const randomParam = `cacheBust=${new Date().getTime()}`;
                setIframeUrl(
                    `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                        documentUrl
                    )}&embedded=true&${randomParam}`
                );
            }
        }
    }, [visibility, documentUrl]);

    const handlePrint = () => {
        window.print();
    };

    return (
        <Modal
            title={title}
            visible={visibility}
            onCancel={onCancel}
            destroyOnClose={true}
            footer={[
                <div style={{display: "flex", flexDirection: "column", gap: "8px"}}>
                    {description && <div>{description}</div>}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "8px"
                        }}
                    >
                        {documentUrl && (
                            <Button
                                key="download"
                                href={documentUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                            >
                                İndir
                            </Button>
                        )}
                        {isNeedForApproval && isApproved !== true && !hasError && isLoaded && (
                            <Button
                                key="approve"
                                type="primary"
                                onClick={onApprove}
                                disabled={isApproveButtonDisabled}
                            >
                                Onayla
                            </Button>
                        )}
                        <Button key="close" onClick={onCancel}>
                            Kapat
                        </Button>
                    </div>
                </div>
            ]}
            width={900}
        >
            {documentUrl ? (
                <div style={{position: "relative", width: "100%", height: "500px"}}>
                    {isLoading && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "white",
                                zIndex: 1
                            }}
                        >
                            <Spin tip="Belge yükleniyor..." />
                        </div>
                    )}
                    <iframe
                        key={iframeUrl}
                        src={iframeUrl}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            visibility: isLoaded ? "visible" : "hidden"
                        }}
                        title="Document Viewer"
                        onLoad={() => {
                            setIsLoaded(true);
                            setIsLoading(false);
                            setHasError(false);
                        }}
                        onError={() => {
                            setHasError(true);
                            setIsLoading(false);
                        }}
                    ></iframe>
                </div>
            ) : (
                <Spin tip="Yükleniyor..." />
            )}

            {hasError && <p style={{color: "red"}}>Belge yüklenemedi. Lütfen tekrar deneyin.</p>}
        </Modal>
    );
};
